/**
 * Public-holiday calendars — the ONE intentional split from the country registry
 * (`businessRules.ts`). Kept collocated and hand-maintained (no holiday library)
 * so any country entity can add/remove a custom date directly. Dates are
 * `yyyy-MM-dd`; blocked in every journey's date picker.
 *
 * These are refreshed on a yearly cadence — the calendar-freshness test fails
 * when a country's list stops covering the current year.
 */
export const HOLIDAYS = {
  austria: [
    '2025-12-08',
    '2025-12-24',
    '2025-12-25',
    '2025-12-26',
    '2025-12-31',
    '2026-01-01',
    '2026-01-06',
    '2026-04-06',
    '2026-05-01',
    '2026-05-14',
    '2026-05-25',
    '2026-06-04',
    '2026-08-15',
    '2026-10-26',
    '2026-11-01',
    '2026-12-08',
    '2026-12-24',
    '2026-12-25',
    '2026-12-26',
    '2026-12-31',
  ],
  norway: [
    '2026-01-01',
    '2026-04-02',
    '2026-04-03',
    '2026-04-05',
    '2026-04-06',
    '2026-05-01',
    '2026-05-14',
    '2026-05-17',
    '2026-05-24',
    '2026-05-25',
    '2026-12-25',
    '2026-12-26',
  ],
  romania: [
    '2025-12-25',
    '2025-12-26',
    '2026-01-01',
    '2026-01-02',
    '2026-01-06',
    '2026-01-07',
    '2026-01-24',
    '2026-04-10',
    '2026-04-13',
    '2026-05-01',
    '2026-06-01',
    '2026-11-30',
    '2026-12-25',
    '2026-12-26',
  ],
  // Both Swedish subsidiaries (75201 Ayvens, 75202 Nordea) share the same calendar
  sweden: [
    '2025-12-24',
    '2025-12-25',
    '2025-12-26',
    '2025-12-31',
    '2026-01-01',
    '2026-01-06',
    '2026-04-03',
    '2026-04-06',
    '2026-05-01',
    '2026-05-14',
    '2026-05-15',
    '2026-06-19',
    '2026-12-24',
    '2026-12-25',
    '2026-12-31',
  ],
} satisfies Record<string, string[]>
